import {
  Dialog,
  DialogContent,
  DialogSubTitle,
  DialogTitle,
  IconButton,
} from '@/components/admin/user/components';
import { ConfirmModalButton } from '@/components/dialogs/component';
import { CloseIcon } from '@/components/icons';
import theme from '@/theme/theme';
import { Box, Button, CircularProgress } from '@mui/material';
import React from 'react';

interface IConfirmModalProps {
  text: string;
  onConfirm: () => void;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  textConfirm?: string;
  confirmStatus: ModalStatuses;
  confirmIcon?: JSX.Element;
  withCloseIcon?: boolean;
  loading?: boolean;
  loadingText?: string;
}

export enum ModalStatuses {
  WARNING = 'warning',
  PRIMARY = 'primary',
}

type IStatusColor = {
  [key in ModalStatuses]: string;
};

const StatusColor: IStatusColor = {
  [ModalStatuses.WARNING]: theme.palette.redColor.main,
  [ModalStatuses.PRIMARY]: 'primary',
};

const ConfirmModal: React.FC<IConfirmModalProps> = ({
  isOpen,
  onClose,
  text,
  onConfirm,
  title = 'Warning',
  textConfirm = 'Continue',
  confirmStatus,
  confirmIcon,
  withCloseIcon = true,
  loading = false,
  loadingText,
}: IConfirmModalProps) => {
  const confirmLabel = loading ? loadingText ?? textConfirm : textConfirm;

  return (
    <Dialog
      onClose={loading ? undefined : onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      maxWidth={'lg'}
    >
      <DialogTitle>
        {title && <div>{title}</div>}
        {withCloseIcon && (
          <IconButton aria-label="close" onClick={onClose} disabled={loading}>
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogSubTitle>{text}</DialogSubTitle>
      <DialogContent>
        <Box display="flex" marginTop={2} justifyContent="center">
          <ConfirmModalButton
            variant="contained"
            color={confirmStatus}
            status={confirmStatus}
            onClick={() => onConfirm()}
            disabled={loading}
          >
            {loading && (
              <CircularProgress
                size={16}
                sx={{ mr: 1, color: theme.palette.common.white }}
              />
            )}
            <Box
              color={
                loading
                  ? theme.palette.common.white
                  : StatusColor[confirmStatus]
              }
            >
              {confirmLabel}
            </Box>
            {confirmIcon && !loading && (
              <Box ml={2} alignItems="center" display="flex">
                {confirmIcon}
              </Box>
            )}
          </ConfirmModalButton>
          <Button
            variant="outlined"
            onClick={onClose}
            color="secondary"
            disabled={loading}
          >
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
